import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='10'
        height='11'
        viewBox='0 0 10 11'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M0 9.63233V1.00141C0 0.242354 0.812477 -0.23996 1.47885 0.123517L9.39052 4.43898C10.0854 4.81799 10.0854 5.81575 9.39053 6.19477L1.47885 10.5102C0.812477 10.8737 0 10.3914 0 9.63233Z'
            fill='#747391'
        />
    </svg>
);

export const PlayIcon = styled(Icon)({});
